// TODO: import accessibleAutocomplete from 'accessible-autocomplete' sobald Webpack verfügbar

class GbaAutocomplete {
    constructor(element) {
        this.element = element;
        this.id = this.element.dataset.autocompleteId ?? '';
        this.jsonUrl = this.element.dataset.autocompleteJsonUrl ?? '';
        this.name = this.element.dataset.autocompleteName ?? this.element.dataset.autocompleteId;
        this.enhanceId = this.element.dataset.autocompleteEnhanceSelectId ?? null;
        this.autocompleteLabel = this.element.dataset.autocompleteLabel ?? '';
        this.defaultValue = this.element.dataset.autocompleteDefaultValue ?? '';

        if (this.id && this.jsonUrl) {
            this.init();
        }
    }

    async init() {
        try {
            const suggestionsPromise = fetch(this.jsonUrl).then(response => { return response.json(); });

            // Ergänze einen Hint im DOM für Behat-Tests
            suggestionsPromise.then(() => {
                this.element.dataset.qa = "autocomplete:ready";
            });

            let defaultOptions = {
                element: this.element,
                id: this.name,
                name: this.name,
                defaultValue: this.defaultValue,
                inputClasses: 'gba-form-widget-text',
                displayMenu: 'overlay',
                autoselect: true,
                source: async (query, populateResults) => {
                    const regex = new RegExp(`(?<![\\p{L}\\p{N}])${query}`, 'iu');
                    const suggestions = await suggestionsPromise;
                    populateResults(suggestions.filter(element => regex.test(element)));
                },
                tStatusNoResults: function() {
                    return 'Keine Resultate.'
                },
                tStatusSelectedOption: function(selectedOption, length, index) {
                    return `${selectedOption} (${index + 1} von ${length}) ist ausgewählt.`
                },
                tStatusResults: function(length, contentSelectedOption) {
                    var words = {
                        result: (length === 1) ? 'Resultat' : 'Resultate',
                        is: (length === 1) ? 'ist' : 'sind'
                    }

                    return `${length} ${words.result} ${words.is} verfügbar. ${contentSelectedOption}`;
                },
                tNoResults: function() {
                    return 'Keine Resultate'
                },
                tAssistiveHint: function() {
                    return 'Wenn automatisch vervollständigte Ergebnisse verfügbar sind, verwenden Sie die Auf- und Abwärtspfeile zum Überprüfen und die Eingabetaste zum Auswählen. Benutzer von Touch-Geräten können durch Berührung oder mit Wischgesten suchen.'
                },
            }

            if (this.enhanceId) {
                const enhanceSelectOptions = {
                    ...defaultOptions,
                    selectElement: document.getElementById(this.enhanceId),
                };

                accessibleAutocomplete.enhanceSelectElement(enhanceSelectOptions);

                if (this.autocompleteLabel) {
                    this.swapLabelAfterEnhancement();
                }
            } else {
                accessibleAutocomplete(defaultOptions);
            }
        } catch (error) {
            console.error('Error:', error);
        }
    }

    swapLabelAfterEnhancement() {
        let label = document.querySelector(`[for="${this.enhanceId}"]`);
        label.textContent = this.autocompleteLabel;
        label.setAttribute('for', this.name);
    }
}

documentReady(function() {
    const autocompleteFields = document.querySelectorAll('.js-autocomplete');

    if (autocompleteFields) {
        autocompleteFields.forEach(field => new GbaAutocomplete(field))
    }
});
